export const team =  [
    {
        "name": "Benedict",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597464767/techopps/A7C886D1-794D-4250-8010-725012B6A35C_v6aaw1.png",
        "link": "https://www.linkedin.com/in/franz-v"
    },
    {
        "name": "VR",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597474847/techopps/978A9232-D5E7-4F09-AD38-9C40FF5426CA_utnbe9.png",
        "link": "https://www.linkedin.com/in/virramon/"
    },
    {
        "name": "Carmeli",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597475105/techopps/2D2A92F3-3208-4E4D-8546-8ECAE8E78C43_luroxy.png",
        "link": "https://www.linkedin.com/in/fcvillamin"
    },
    {
        "name": "Virmon",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597464767/techopps/B475D2C7-EF51-4AF7-B5B2-219181A28356_twtztw.png",
        "link": "https://www.linkedin.com/in/virmtumulak"
    },
    {
        "name": "Moniqa",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597464767/techopps/B9E522B0-F8DD-4258-A384-DF2528CC1240_mzjc5i.png",
        "link": "https://www.linkedin.com/in/rmktumulak"
    },
    {
        "name": "Ragine",
        "img": "https://res.cloudinary.com/rmkt/image/upload/v1597464767/techopps/205E1C35-70D4-4825-9BE2-5E8497D9E4D5_f89h0i.png",
        "link": "https://www.linkedin.com/in/raginetumulak"
    },
]
